const c = {
  id: "yScaleTitlePlugin",
  afterDatasetsDraw: (e, i, a) => {
    const {
      ctx: t,
      chartArea: { top: l }
    } = e, { title: r, enabled: s } = a;
    s && (t.save(), t.fillStyle = "#606060", t.fillText(r || "", 5, l - 20), t.restore());
  }
};
export {
  c as default
};
//# sourceMappingURL=index.es72.js.map
